import type { ReactElement } from 'react'
import type { ITemplateProps } from '~/types/template'

import BaseTemplate from '../Base'

import './styles.scss'

export const OnBoardingPortraitTemplate = (props: ITemplateProps): ReactElement => {
  return <BaseTemplate {...props} className="on-boarding-template" />
}

export const OnBoardingLandscapeTemplate = (props: ITemplateProps): ReactElement => {
  return <BaseTemplate {...props} className="on-boarding-template landscape" />
}
